










import { defineComponent } from '@nuxtjs/composition-api'
import { addBasePath } from '~/helpers/addBasePath';

export default defineComponent({
    setup() {
        const images = [
            {
                url: addBasePath('/resources/solepro/images/payment-icons/visa-logo.png'),
                alt:"visa logo"
            },
            {
                url: addBasePath('/resources/solepro/images/payment-icons/Mastercard.png'),
                alt: "mastercard logo"
            },
            {
                url: addBasePath('/resources/solepro/images/payment-icons/AMEX.png'),
                bgColor: "#1F72CD",
                classes: 'py-0 px-0',
                alt: 'amex logo'
            },
            {
                url: addBasePath('/resources/solepro/images/payment-icons/PayPal.png'),
                classes: 'py-0 px-0',
                alt: "paypal logo"
            },
            {
                url: addBasePath('/resources/solepro/images/payment-icons/satispay.png'),
                alt: 'satispay logo'
            },
        ]
        return { images }
    },
})
